import script from "./UserAnsweredSurveys.vue?vue&type=script&setup=true&lang=js"
export * from "./UserAnsweredSurveys.vue?vue&type=script&setup=true&lang=js"

import "./UserAnsweredSurveys.vue?vue&type=style&index=0&id=a4ced742&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4ced742"]])

export default __exports__